// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseButton_button__83s8_","icon":"CloseButton_icon__lMJHA","water":"CloseButton_water__zRUFN","rotate":"CloseButton_rotate__QdmhK","pulsate":"CloseButton_pulsate__cYxzE"};